/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */
import { kahuCopyInfoType } from 'types/kahu';

import { FACT_NAME_LABEL_MAP } from '../components/display-page/fact-name-label-map';

export const copyLabelWithFact = (
  copiedInfo: kahuCopyInfoType | null
): string => {
  if (!copiedInfo) return '';

  const factKeys = Object.entries(FACT_NAME_LABEL_MAP);

  switch (copiedInfo.copiedContentType) {
    case 'traceId': {
      // Extracting factName from the href
      const factName = copiedInfo.href.match(/[?&]factName=([^&#]+)/)?.[1];
      const factLabel = factKeys.find((fact) => fact[0] === factName);
      return factLabel ? `${factLabel[1].idLabel} ${copiedInfo?.text}` : '';
    }

    case 'appName':
      return `Application ${copiedInfo.text}`;
    case 'workflowName':
      return `Workflow ${copiedInfo.text}`;
    default:
      return '';
  }
};
